module.exports = __webpack_public_path__ + "img/upload-blue.20fa74fa.svg";